import ThisModule from "./PageInterest";

export default ThisModule;
